// import axios, { AxiosRequestConfig, AxiosResponse, AxiosInstance } from 'axios';
import Actions from '../actions';
import Button from '../../../../components/form/button.jsx';
import ControlGroup from '../../../../components/form/control-group.jsx';
import React from 'react';
import {Helmet} from 'react-helmet';
import {Link} from 'react-router-dom';
import Spinner from '../../../../components/form/spinner.jsx';
import Store from './store';
import TextControl from '../../../../components/form/text-control.jsx';
// const { Recaptcha } = require('../../../../components');
// const { handleLocalStateChange } = require('../../../../utils/react');

const scriptId = '_se_script';
let widgetId;
let cbSuccess = () => {};
let cbError = () => {};
let styledAdded = false;

const getFromLocalStorage = function(key) {
  if (typeof window !== 'undefined' && window.localStorage) {
    let entry;
    try {
      entry = window.localStorage.getItem(key);
    } catch (error) {
      console.error('getFromLocalStorage', error);
      return undefined;
    }

    try {
      entry = JSON.parse(entry);
    } catch (e) {
      // Just use raw value
    }

    const storedValue = entry && entry.value !== undefined ? entry.value : entry;
    return storedValue;
  }
  return undefined;
}

class LoginPage extends React.Component {
  constructor(props) {

    super(props);

    this.input = {};
    this.state = Store.getState();
  }

  componentDidMount() {
    this.loadSecurityScript();

    Actions.getUserCreds();

    this.unsubscribeStore = Store.subscribe(this.onStoreChange.bind(this));

    if (this.input.email) {
      this.input.email.focus();
    }
  }

  componentWillUnmount() {
    this.unsubscribeStore();
    Actions.resetStore();
  }

  onStoreChange() {
    this.setState(Store.getState());

    if (this.state.captchaSecurityId && !this.state.displayedCaptcha) {
      this.setState({
        displayedCaptcha: true,
      });
      this.handleSubmit();
    }
  }

  async handleSubmit(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    await this.loadFingerprintScript();

    let deviceInfo = '';
    let fvideoId = '';

    if (getFromLocalStorage('__BNC_FP_INFO__')) {
      deviceInfo = encodeURIComponent(getFromLocalStorage('__BNC_FP_INFO__')) || '';
      fvideoId = getFromLocalStorage('BNC_FV_KEY') || '';
    }

    let captcha = '';
    if (this.state.captchaSecurityId) {
      const { challenge, token } = await this.handleBinanceSecurity(this.state.captchaSecurityId, this.state.captchaBizCode);
      captcha = token;
    }

    Actions.login({
      email: this.input.email.value(),
      password: this.input.password.value(),
      captcha,
      securityId: this.state.captchaSecurityId,
      deviceInfo,
      fvideoId,
    });
  }

  render() {

    const alerts = [];

    if (this.state.success) {
      alerts.push(
        <div key="success" className="alert alert-success">
          Loading...
        </div>
      );
    }

    if (this.state.validation.error) {
      alerts.push(
        <div key="danger" className="alert alert-danger">
          {this.state.validation.error}
        </div>
      );
    }

    // if (this.state.captchaSecurityId) {
    //   alerts.push(
    //     <div key="danger" className="alert alert-danger">
    //       Captcha is required. Please try again!
    //     </div>
    //   );
    // }

    let formElements;

    if (!this.state.success) {
      formElements = (
        <fieldset>
          <TextControl
            ref={(c) => (this.input.email = c)}
            name="email"
            label="Email address"
            type="email"
            autocomplete="email"
            hasError={this.state.validation.hasError.email}
            help={this.state.validation.help.email}
            disabled={this.state.loading}
            maxlength="256"
          />
          <TextControl
            ref={(c) => (this.input.password = c)}
            name="password"
            label="Password"
            type="password"
            autocomplete="current-password"
            hasError={this.state.validation.hasError.password}
            help={this.state.validation.help.password}
            disabled={this.state.loading}
            maxlength="72"
          />

          <ControlGroup hideLabel={true} hideHelp={true}>
            <Button
              type="submit"
              inputClasses={{ 'btn-primary': true }}
              disabled={this.state.loading}>

              Log in
              <Spinner space="left" show={this.state.loading} />
            </Button>
            <Link to="/login/forgot" className="btn btn-link">
              Forgot your password?
            </Link>
          </ControlGroup>
        </fieldset>
      );
    }

    return (
      <section className="container">
        <Helmet>
          <title>Log in</title>
        </Helmet>

        <div className="login-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
          <h1 className="display-4">Log In</h1>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-12">
              <form className="auth-form" onSubmit={this.handleSubmit.bind(this)} method="post">
                {alerts}
                {formElements}
              </form>
            </div>
          </div>
          <div className="row auth-form-tip">
            <p className="text-center">Don’t have an account? <Link className="btn btn-link" title="Log In" to="/signup">Get an API Key now.</Link></p>
          </div>
        </div>
      </section>
    );
  }

  // recaptcha
  loadSecurityScript() {
    if (document.querySelector(`script#${scriptId}`)) {
      return Promise.resolve();
    } else {
      return new Promise(res => {
        const scriptTag = document.createElement('script');
        scriptTag.src = 'https://public.bnbstatic.com/static/js/se/se.min.js';
        scriptTag.id = scriptId;
        scriptTag.setAttribute('apiServer', 'api.commonservice.io/gateway-api');
        scriptTag.onload = res;
        document.head.appendChild(scriptTag);
      });
    }
  }

  staticUrlRaw(pathname) {
    return `/public/static${pathname}`;
  }

  loadBinanceScript() {
    return new Promise((resolve, reject) => {
      if (!document.getElementById('cmc-binance-captcha-sdk') || !window['BCaptcha']) {
        const script = document.createElement('script');
        const scriptSrc = this.staticUrlRaw('/captcha/captcha-sdk.js');
        // from https://staticrecap.cgicgi.io/static/js/captcha/captcha-sdk-v2.14.278.min.js
        script.id = 'cmc-binance-captcha-sdk';
        script.src = scriptSrc;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
        return;
      }

      resolve(true);
    });
  }

  loadFingerprintScript() {
    return new Promise((resolve, reject) => {
      if (!window['initFingerPrintSDK']) {
        const script = document.createElement('script');
        const scriptSrc = this.staticUrlRaw('/fingerPrint/finger-print-sdk-beta.js');
        script.id = 'cmc-binance-fingerprint-sdk';
        script.src = scriptSrc;
        script.onload = function () {
          if (window['initFingerPrintSDK']) {
            window['initFingerPrintSDK']({
              t: 'cmc',
              domain: 'https://api.commonservice.io',
            });
          }
          setTimeout(() => {
            resolve(true);
          }, 300);
        };
        script.onerror = reject;
        document.head.appendChild(script);
      } else {
        resolve(true);
      }
    });
  }

  async handleBinanceSecurity(securityId, bizCode) {
    await this.loadBinanceScript();

    const options = {
      bizId: bizCode || 'CMC_login',
      staticHost: 'https://staticrecap.cgicgi.io',
      apiHost: 'https://api.commonservice.io',
      apiBasePath: '/gateway-api/v1/public/antibot',
      i18nHost: 'https://bin.bnbstatic.com',
      lang: 'en',
      theme: 'auto',
    };

    const captchaObj = new window.BCaptcha(options);

    return new Promise((resolve, reject) => {
      captchaObj.show({
        securityCheckResponseValidateId: securityId,
        onValidateSuccess: function (challenge, token) {
          resolve({ 
            challenge,
            token,
          });
        },
        onValidateFail: function (message) {

        },
        onError: function (errorMessage) {
          reject({
            challenge: '',
            token: '',
          });
        },
        onClose: function (errorMessage) {
          resolve({
            challenge: '',
            token: '',
          });
        },
      });
    });
  }
}


export default LoginPage;



// WEBPACK FOOTER //
// ./client/pages/main/login/home/index.jsx